// Format anything thrown into a readable string. Supabase errors are plain
// objects with .message / .code / .details / .hint, so the default
// `e instanceof Error ? e.message : String(e)` falls through to
// "[object Object]". Walk the common shapes here.

export function formatError(e: unknown): string {
  if (e == null) return 'Unknown error';
  if (typeof e === 'string') return e;
  if (e instanceof Error) return e.message;

  if (typeof e === 'object') {
    const obj = e as {
      message?: unknown;
      msg?: unknown;
      error?: unknown;
      details?: unknown;
      hint?: unknown;
      code?: unknown;
    };
    const parts: string[] = [];
    const message =
      typeof obj.message === 'string'
        ? obj.message
        : typeof obj.msg === 'string'
          ? obj.msg
          : typeof obj.error === 'string'
            ? obj.error
            : null;
    if (message) parts.push(message);
    if (typeof obj.details === 'string' && obj.details.length > 0) parts.push(obj.details);
    if (typeof obj.hint === 'string' && obj.hint.length > 0) parts.push(`hint: ${obj.hint}`);
    if (typeof obj.code === 'string' && obj.code.length > 0) parts.push(`(${obj.code})`);
    if (parts.length > 0) return parts.join(' — ');
  }

  try {
    return JSON.stringify(e);
  } catch {
    return String(e);
  }
}
